import React, {Component} from 'react';
import * as firebase from 'firebase';
import {Image, Rect, Line, Group} from 'react-konva';

/** @class EditableBoothIcon
  * A component for resizing and positioning a booth
  * within a hall.
  * @prop {String} name - the booth name
  * @prop {url} icon - the booth image
  * @prop {integer} x - the x position of the booth icon in the hall
  * @prop {integer} y - the y positio of the booth icon in the hall
  * @prop {integer} width - the width of the booth icon in the hall
  * @prop {integer} height - the height of the booth icion in the hall
  * @prop {string} dataURL - the booth's firebase url
  */
export default class EditableBoothIcon extends Component {
  /** @constructor
    * Constructs a new EditableBoothIcon
    */
  constructor(props) {
    super(props);
    this.state = {image: null, width: 100, height: 100}
    this.handleDrag = this.handleDrag.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }
  /** @method componentWillMount
    * Loads the booth icon image.
    */
  componentWillMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({
        image: image,
        width: image.width,
        height: image.height
      });
    }
    image.src = this.props.icon;
  }
  /** @method handleDrag
    * Repositions the booth icon in the hall and submits
    * the changes to the firebase database.
    * @param {Event} event - the triggering event
    * @param {Object} ui - the new position in the hall.  Should have an x and y property.
    */
  handleDrag(event) {
    var updates = {
      [`${this.props.dataURL}/x`]: event.target.attrs.x,
      [`${this.props.dataURL}/y`]: event.target.attrs.y
    }
    firebase.database().ref().update(updates);
  }
  /** @method handleResize
    * Resizes the booth icon and submits
    * the changes to the firebase database.
    * @param {integer} delta - the change in scale
    */
  handleResize(delta) {
    firebase.database()
    .ref(`${this.props.dataURL}/scale`)
    .set((this.props.scale || 1) * delta);
  }
  /** @method render
    * Renders the booth icon with drag and scale
    * controls.
    */
  render() {
    const scale = this.props.scale || 1.0;
    const width = this.state.image ? this.state.image.width * scale : 100;
    const height = this.state.image ? this.state.image.height * scale : 100;
    const opacity = this.props.published ? 1.0 : 0.5;
    return (
      <Group
        x={this.props.x}
        y={this.props.y}
        draggable
        onDragEnd={this.handleDrag}
      >
        <Rect
          width={width}
          height={height}
          stroke="black"
          />
        <Image
          opacity={opacity}
          image={this.state.image}
          width={width}
          height={height}
          onMouseEnter={()=>{document.body.style.cursor = 'move'}}
          onMouseLeave={()=>{document.body.style.cursor = 'default'}}
          />
        <Rect
          x={5}
          y={5}
          width={20}
          height={20}
          stroke="darkgray"
          fill="silver"
          onMouseEnter={()=>{document.body.style.cursor = 'pointer'}}
          onMouseLeave={()=>{document.body.style.cursor = 'default'}}
          onClick={()=>this.handleResize(1.1)}
          />
        <Line
          points={[8, 15, 22, 15]}
          stroke="black"
          />
        <Line
          points={[15, 8, 15, 22]}
          stroke="black"
          />
        <Rect
          x={25}
          y={5}
          width={20}
          height={20}
          stroke="darkgray"
          fill="silver"
          onMouseEnter={()=>{document.body.style.cursor = 'pointer'}}
          onMouseLeave={()=>{document.body.style.cursor = 'default'}}
          onClick={()=>this.handleResize(0.9)}
          />
        <Line
          points={[28, 15, 42, 15]}
          stroke="black"
          />
      </Group>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/hall-editor/editable-booth-icon.js